import { environmentActionTypes } from '@constants/actionTypes/commonActionTypes';
import states from '@constants/configs/states';
import externalEndpoints from '@constants/configs/externalEndpoints';
import { languageTypes } from '@constants/common/languageTypes';
import { compareStringsCaseInsensitively } from '@utils/miscellaneous/compareStrings';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { set } from '@utils/miscellaneous/objectHelpers';

export const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case environmentActionTypes.SET_ENVIRONMENTS: {
            const envData = action.envData;
            return {
                ...envData,
                reduxUnreadMessageCount: state?.reduxUnreadMessageCount ?? 0
            };
        }
        case environmentActionTypes.CHANGE_LANG:
            if (state !== null && state.stateCode === states.NEW_JERSEY) {
                return {
                    ...state,
                    language: action.language,
                    links: {
                        ...state.links,
                        HELP: action.language === languageTypes.SPANISH ?
                            externalEndpoints.NJ_LINKS.HELP_LINK_ES :
                            externalEndpoints.NJ_LINKS.HELP_LINK_EN
                    }
                };
            }
            return {
                ...state,
                language: action.language
            };
        case environmentActionTypes.UPDATE_EXPLAINER_DATA:
            return {
                ...state,
                explainerData: {
                    [action.pageName]: action.data
                }
            };
        case environmentActionTypes.UPDATE_ICON_UNREAD_COUNT: {
            const { numberUnread } = action;
            if (numberUnread !== null && numberUnread !== undefined) {
                return {
                    ...state,
                    reduxUnreadMessageCount: numberUnread
                };
            }
            return state;
        }
        case environmentActionTypes.INCREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT: {
            return {
                ...state,
                communicationPrefReviewCount: state.communicationPrefReviewCount + 1
            };
        }
        case environmentActionTypes.DECREMENT_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT: {
            if(!state.communicationPrefReviewCount) return state;
            return {
                ...state,
                communicationPrefReviewCount: state.communicationPrefReviewCount - 1
            };
        }
        case environmentActionTypes.UPDATE_COMMUNICATION_PREFERENCE_CONFIRMATION_COUNT: {
            return {
                ...state,
                communicationPrefReviewCount: action.communicationPrefReviewCount
            };
        }
        case environmentActionTypes.UPDATE_PROP: {
            const newState = state ? { ...state } : {};
            set(newState, action.path, action.value);
            return newState;
        }
        case environmentActionTypes.CLEAR_COMMON_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const getIsForAdminOrOperations = (state) => {
    const activeModuleName = state?.user?.activeModuleName ?? '';
    return compareStringsCaseInsensitively(
        activeModuleName,
        ALL_USER_ROLES.ADMIN,
        ALL_USER_ROLES.OPERATIONS
    );
};
export const getIsState = state => state.isState;
export const getTicketEnabled = state => state.ticketEnabled;
export const getStateCode = state => state.stateCode;
export const getLanguage = state => state.language;
export const getServerDate = state => state.localDates?.serverDate;
export const getPhoneNumber = state => state.links?.PHONE;